import {DataGridPageState, DispatchRequestFilterFormValues, GridSort} from "@ots-frontend/ots-ui";
import {createAction} from "@reduxjs/toolkit";

export const setDispatchRequestPageFilter = createAction<DispatchRequestFilterFormValues>("ui/dispatch-request-page/setFilter");
export const setDispatchRequestPageState = createAction<DataGridPageState>("ui/dispatch-request-page/setState");
export const setDispatchRequestPageStateCell = createAction<[col: number, row: number]>("ui/dispatch-request-page/setStateCell");
export const setDispatchRequestPageStateWidths = createAction<(number | undefined)[]>("ui/dispatch-request-page/setStateWidths");
export const setDispatchRequestPageStateSort = createAction<GridSort | undefined>("ui/dispatch-request-page/setStateSort");
